<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">商品分类修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item label="图标" required >
                                    <el-upload
                                    class="upload-demo"
                                        :action="uploadUrl"
                                        list-type="picture-card"
                                        :data='uploadData'
                                        :show-file-list="false"
                                        :on-success="handleImgSuccess"
                                        style="width:100%;margin-top:40px">
                                        <img v-if="editForm.icon" :src="editForm.icon" fit='cover'  class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="名称" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="排序" required prop="sort">
                                    <el-input v-model.number="editForm.sort" placeholder="请输入排序"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="是否团购" required prop="isGroup">
                                    <el-radio-group v-model="editForm.isGroup" style="width:100%">
                                        <el-radio :label="1">是</el-radio>
                                        <el-radio :label="2">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="商品属性">
                                    <el-select v-model="editForm.goodsAttributeCodeList" multiple placeholder="请选择" style="width:100%">
                                        <el-option
                                            v-for="item in attributeList"
                                            :key="item.goodsAttributeCode"
                                            :label="item.name"
                                            :value="item.goodsAttributeCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="物品类型状态" required prop="status">
                                    <el-select v-model="editForm.status" placeholder="请选择状态" @change="changeStatus" style="width:100%">
                                        <el-option
                                                v-for="item in status2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        props:['attributeList'],
        data() {
            return {
                loading: false,
                iconDialog: false,
                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    name:'',
                    goodsClassCode:'',
                    staffCode:getStaffCode(),
                    goodsAttributeCodeList:'',
                    parentGoodsClassCode:'',
                    sort:'',
                    icon:'',
                    isGroup:'',
                    status:0,
                },
                status2: [{
                    value: 1,
                    label: '正常'
                }, {
                    value: 2,
                    label: '禁用'
                }],
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],
                    isGroup:[
                        { required: true, message: '请选择是否团购', trigger: 'blur' },
                    ],
                    goodsAttributeCodeList:[
                        { required: true, message: '请选择属性', trigger: 'blur' },
                    ]

                }

            }
        },
        methods: {
            init(row){
                this.editForm.goodsClassCode = row.goodsClassCode;
                this.editForm.parentGoodsClassCode = row.parentGoodsClassCode;
                this.editForm.name = row.name;
                this.editForm.sort = row.sort;
                this.editForm.status = row.status;
                this.editForm.isGroup = row.isGroup;
                this.editForm.icon = this.$imgUrl+row.icon;
                var list=[]
                for(var i in row.goodsAttributeList){
                    list.push(row.goodsAttributeList[i].goodsAttributeCode)
                }
                this.editForm.goodsAttributeCodeList=list
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            handleImgSuccess(res) {
                this.editForm.icon = this.$imgUrl+res.data.path;
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        if(!this.editForm.icon){
                            this.$message({type: 'warning', message: '请上传商品图标'});
                            return;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
            changeStatus:function (selVal) {
                this.editForm.status = selVal;
            },
            iconPreview() {
                this.iconDialog = true;
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.editForm.icon=this.editForm.icon.replace(this.$imgUrl,'')
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClass/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },

        }
    }


</script>




<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;
            .modal-body /deep/ .el-upload--picture-card{
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
             .modal-body .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width:100px;
                height: 100px;
            }
            .modal-body .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 100px;
                height: 100px;
                line-height: 100px;
                text-align: center;
            }
            .modal-body .avatar {
                width: 100%;
                height: 100%;
                border-radius: 6px;
                display: block;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }
            .uploadButton{
                border-top: 1px solid #eee;
                padding: 10px 0 0;
                display: flex;
                 .el-button{
                    width: 100px;
                }
            }

        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
